import { ETH } from '../constants/assets'
import type { ChainConfig } from '../types'
import { getQuickNodeRpcUrl } from '../utils/getQuickNodeRpcUrl'

export const OPTIMISM = {
  name: 'optimism',
  chainId: 10,
  averageBlockTimeSeconds: 2,
  explorerUrl: 'https://optimistic.etherscan.io',
  nativeAsset: ETH,
  slip44: 60,
  wrappedNativeAsset: '0x4200000000000000000000000000000000000006',
  blockscoutApiUrl: 'https://optimism.blockscout.com/api',
  etherscanSupported: true,
  publicRpcUrls: ['https://optimism.drpc.org', 'https://optimism.llamarpc.com', 'https://1rpc.io/op'],
  getPrivateRpcUrls: () => {
    const optimism: string[] = []
    process.env.ROUTEME_API_KEY && optimism.push(`https://lb.routeme.sh/rpc/10/${process.env.ROUTEME_API_KEY}`)
    const quickNodeUrl = getQuickNodeRpcUrl('optimism')
    quickNodeUrl && optimism.push(quickNodeUrl)
    process.env.INFURA_API_KEY && optimism.push(`https://optimism-mainnet.infura.io/v3/${process.env.INFURA_API_KEY}`)
    process.env.ALCHEMY_API_KEY && optimism.push(`https://opt-mainnet.g.alchemy.com/v2/${process.env.ALCHEMY_API_KEY}`)
    process.env.ANKR_API_KEY && optimism.push(`https://rpc.ankr.com/optimism/${process.env.ANKR_API_KEY}`)
    return optimism
  },
} as const satisfies ChainConfig
